import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

export interface CommunityConfirmationCardProps {
  activity_scores_enabled?: boolean;
  ai_summaries_enabled?: boolean;
  allow_members_to_go_live?: boolean;
  allow_moderator_csv_download?: boolean;
  allow_profile_search_indexing?: boolean;
  brand_color?: string;
  brand_dark_color?: string;
  community_switcher_enabled?: boolean;
  content_copilot_enabled?: boolean;
  custom_cta_for_share_links?: boolean;
  custom_sign_up?: boolean;
  deactivate_account_enabled?: boolean;
  default_search_sorting?: string;
  desktop_app_enabled?: boolean;
  enable_state_param?: boolean;
  enforce_otp_for_signup?: boolean;
  group_messaging_enabled?: boolean;
  hide_circle_discover?: boolean;
  hide_emails_on_member_profiles?: boolean;
  ios_app_enabled?: boolean;
  is_private?: boolean;
  legal_address?: string;
  legal_email?: string;
  locale?: string;
  member_to_member_messaging_enabled?: boolean;
  messaging_enabled?: boolean;
  name?: string;
  reply_to_email?: string;
  show_ios_app_banner?: boolean;
  sso_enabled?: boolean;
  truncate_post_body_in_email_notifications?: boolean;
  voice_messages_enabled?: boolean;
  weekly_digest_enabled?: boolean;
  white_label?: boolean;
}

export const CommunityConfirmationCard = (
  props: CommunityConfirmationCardProps,
) => {
  const formatBoolean = (value: string | boolean | undefined) => {
    if (typeof value === "boolean") {
      return value
        ? t("help_widget.copilot.confirmation_card.yes")
        : t("help_widget.copilot.confirmation_card.no");
    }
    return value;
  };

  const attributes = [
    {
      label: t("help_widget.copilot.confirmation_card.community_name"),
      value: props.name,
    },
    {
      label: t("help_widget.copilot.confirmation_card.community_locale"),
      value: props.locale,
    },
    {
      label: t("help_widget.copilot.confirmation_card.community_is_private"),
      value: formatBoolean(props.is_private),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_desktop_app_enabled",
      ),
      value: formatBoolean(props.desktop_app_enabled),
    },
    {
      label: t("help_widget.copilot.confirmation_card.community_brand_color"),
      value: props.brand_color,
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_brand_dark_color",
      ),
      value: props.brand_dark_color,
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_reply_to_email",
      ),
      value: props.reply_to_email,
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_switcher_enabled",
      ),
      value: formatBoolean(props.community_switcher_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_deactivate_account_enabled",
      ),
      value: formatBoolean(props.deactivate_account_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_allow_profile_search_indexing",
      ),
      value: formatBoolean(props.allow_profile_search_indexing),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_truncate_post_body_in_email_notifications",
      ),
      value: formatBoolean(props.truncate_post_body_in_email_notifications),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_custom_cta_for_share_links",
      ),
      value: formatBoolean(props.custom_cta_for_share_links),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_default_search_sorting",
      ),
      value: props.default_search_sorting,
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_hide_emails_on_member_profiles",
      ),
      value: formatBoolean(props.hide_emails_on_member_profiles),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_allow_members_to_go_live",
      ),
      value: formatBoolean(props.allow_members_to_go_live),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_allow_moderator_csv_download",
      ),
      value: formatBoolean(props.allow_moderator_csv_download),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_ios_app_enabled",
      ),
      value: formatBoolean(props.ios_app_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_show_ios_app_banner",
      ),
      value: formatBoolean(props.show_ios_app_banner),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_weekly_digest_enabled",
      ),
      value: formatBoolean(props.weekly_digest_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_messaging_enabled",
      ),
      value: formatBoolean(props.messaging_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_member_to_member_messaging_enabled",
      ),
      value: formatBoolean(props.member_to_member_messaging_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_group_messaging_enabled",
      ),
      value: formatBoolean(props.group_messaging_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_voice_messages_enabled",
      ),
      value: formatBoolean(props.voice_messages_enabled),
    },
    {
      label: t("help_widget.copilot.confirmation_card.community_legal_email"),
      value: props.legal_email,
    },
    {
      label: t("help_widget.copilot.confirmation_card.community_legal_address"),
      value: props.legal_address,
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_hide_circle_discover",
      ),
      value: formatBoolean(props.hide_circle_discover),
    },
    {
      label: t("help_widget.copilot.confirmation_card.community_white_label"),
      value: formatBoolean(props.white_label),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_enforce_otp_for_signup",
      ),
      value: formatBoolean(props.enforce_otp_for_signup),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_content_copilot_enabled",
      ),
      value: formatBoolean(props.content_copilot_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_activity_scores_enabled",
      ),
      value: formatBoolean(props.activity_scores_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_ai_summaries_enabled",
      ),
      value: formatBoolean(props.ai_summaries_enabled),
    },
    {
      label: t("help_widget.copilot.confirmation_card.community_sso_enabled"),
      value: formatBoolean(props.sso_enabled),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_enable_state_param",
      ),
      value: formatBoolean(props.enable_state_param),
    },
    {
      label: t(
        "help_widget.copilot.confirmation_card.community_custom_sign_up",
      ),
      value: formatBoolean(props.custom_sign_up),
    },
  ];

  return (
    <ConfirmationCardLayout
      title={t("help_widget.copilot.confirmation_card.title_community")}
      attributes={attributes}
    />
  );
};
